import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { getCampaignAttribution } from "./campaignAttribution";
import { advertisingChoice, metaPixelConfigured, setAdvertisingChoice, trackPublicPage } from "./marketingTracking";

export function MarketingControls() {
  const [location] = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    getCampaignAttribution();
    if (metaPixelConfigured) { setOpen(!advertisingChoice()); trackPublicPage(location); }
  }, [location]);
  if (!metaPixelConfigured) return null;
  function choose(allowed: boolean) {
    setAdvertisingChoice(allowed);
    setOpen(false);
    if (allowed) trackPublicPage(location);
  }
  return <aside aria-label="Advertising privacy" style={{position:"fixed",bottom:16,left:16,right:16,zIndex:1000,maxWidth:520,padding:16,border:"1px solid #cdd5e0",borderRadius:12,background:"white",color:"#17243a",boxShadow:"0 4px 24px #17243a20",fontSize:14}}>
    {open ? <><strong>Optional advertising measurement</strong><p>Allow Meta to measure page visits and submitted enquiries? This helps us understand our ads. Your choice does not affect the service. See our <a href="/cookies">cookie notice</a>.</p><div style={{display:"flex",gap:12,flexWrap:"wrap"}}><button type="button" onClick={() => choose(false)}>Reject optional</button><button type="button" onClick={() => choose(true)}>Allow advertising</button></div></> : <button type="button" onClick={() => setOpen(true)}>Advertising privacy choices</button>}
  </aside>;
}
